import aframe from "aframe"

aframe.registerComponent('rotateTo', {
    dependencies: ["rotation"],

    schema: {
        velocity: { type: 'number', },
        toY: { type: 'number', },
    },

    init: function () {
        
    },

    tick: function (time, deltaTime) {
        // this.attrValue

        this.el.emit("elTick", {time: time, deltaTime: deltaTime})

        

    } 
})


// WEBPACK FOOTER //
// ./src/components-aframe/rotateTo.js